import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function MatchIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M2.46 11.197c2.332-2.442 5.644-2.557 8 0m-1.504-6.5c0 1.381-1.121 2.5-2.504 2.5a2.502 2.502 0 0 1-2.504-2.5c0-1.38 1.121-2.5 2.504-2.5a2.502 2.502 0 0 1 2.504 2.5ZM14.461 22.197c2.332-2.442 5.644-2.557 8 0m-1.505-6.5c0 1.381-1.12 2.5-2.503 2.5a2.502 2.502 0 0 1-2.504-2.5c0-1.38 1.121-2.5 2.504-2.5a2.502 2.502 0 0 1 2.503 2.5Z" />
      <path d="M3.46 14.197c0 3.87 3.13 7 7 7l-1-2" />
      <path d="M15.476 2.974c1.073-.64 2.01-.381 2.572.03.23.168.346.252.413.252.068 0 .184-.084.414-.253.563-.41 1.499-.668 2.571-.029 1.408.84 1.727 3.61-1.52 5.946-.619.445-.928.668-1.465.668-.536 0-.845-.223-1.464-.668-3.247-2.336-2.928-5.106-1.52-5.946Z" />
    </SvgIcon>
  );
}
